import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { TokenStorageService } from '../services/token-storage/token-storage.service';
import { User } from '../models/user';
import { ApplicationService } from '../services/application.service';
import { DownloadService } from '../services/download/download.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email = new FormControl("", [Validators.required]);
  password = new FormControl("", [Validators.required]);
  hidePassword = true;
  form: any = {
    username: null,
    password: null,
  };
  isLoggedIn = false;
  isLoginFailed = false;
  isLoading = false;
  errorMessage = "";
  roles: string[] = [];

  constructor(
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private applicationService: ApplicationService,
    private downloadService: DownloadService,
  ) { }

  ngOnInit(): void {
    this.tokenStorage.signOut();
  }

  onSubmit(): void {
    this.isLoginFailed = false;
    this.isLoading = true;
    this.authService.login(this.email.value, this.password.value)
      .pipe(catchError(() => of()))
      .subscribe(
        (data) => {
          this.isLoading = false;
          if (data && data.token && data.user) {
            this.tokenStorage.saveToken(data.token);
            this.tokenStorage.saveUser(data.user);

            if (data.photo) {
              this.applicationService.profilePicture = this.downloadService.downloadUrl(5, data.photo);
            } else {
              this.applicationService.profilePicture = '/assets/images/users/' + (data.gender?.id === 1 ? 'male-pp.jpg' : 'female-pp.jpg');
            }

            this.isLoginFailed = false;
            this.isLoggedIn = true;
            window.location.href = "/";
          } else {
            this.isLoginFailed = true;
            this.errorMessage = 'Periksa kembali NIP dan password Anda';
          }
        },
        (err) => {
          this.errorMessage = err.error.message;
          this.isLoginFailed = true;
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
          this.isLoginFailed = true;
        },
      );
  }

  getEmailErrorMessage() {
    if (this.email.hasError("required")) {
      return "Harus diisi";
    }

    return this.email.hasError("email") ? "Email tidak valid" : "";
  }

  getPasswordErrorMessage() {
    if (this.password.hasError("required")) {
      return "Harus diisi";
    }
    return "";
  }

}
